<template>
  <v-card
    min-width="500"
    class="primary fill-height rounded-0 d-flex flex-column justify-space-between"
    style="padding: 35px; min-height: 850px;">
    <v-container
      fluid
      class="fill-height">
      <div
        class="fill-height d-flex flex-column align-content-space-between">
        <v-row>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Nome do Beneficiário"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="formatter.capitalizeText(beneficiary.insuredName)"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="CPF"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.insuredDocumentNumber ? formatter.formatCpf(beneficiary.insuredDocumentNumber.toString()) : '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Data de nascimento"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="formatter.formatDate(beneficiary.birthDate) || '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Idade"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="`${beneficiary.insuredAge} anos` || '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Código Familiar"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.familyCode || '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Sequencial"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.familyCodeSeq || '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Parentesco"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.kinshipName ? formatter.capitalizeText(beneficiary.kinshipName) : '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
        </v-row>

        <v-divider style="width: 100%;" class="my-4 foreground-accent" />

        <v-row>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Nome do Titular"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="formatter.capitalizeText(beneficiary.holderName)"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="CPF do Titular"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.holderDocumentNumber ? formatter.formatCpf(beneficiary.holderDocumentNumber.toString()) : '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Matrícula do Titular"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.holderRegistrationPlate || '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Complemento"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.holderRegistrationComplement || '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Carteirinha do Titular"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.holderBeneficiaryCard || '—'"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
        </v-row>

        <v-divider style="width: 100%;" class="my-4 foreground-accent" />

        <v-row>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Operadora"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.carrierName"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Plano"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="formatter.capitalizeText(beneficiary.planCode)"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Apólice"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="beneficiary.policy"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
          <v-col cols="6">
            <TwoLineCell
              firstLine="Subcontrato"
              :firstLineClass="requestFirstLine.class"
              :firstLineStyle="requestFirstLine.style"
              :secondLine="`${beneficiary.subcontractNumber} ${beneficiary.benefitType}`"
              :secondLineClass="requestSecondLine.class"
              :secondLineStyle="requestSecondLine.style"
            />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import Formatters from '@/shared/formatters/formatters';
import TwoLineCell from '@/components/Default/TwoLineCell.vue';
import { mapGetters } from 'vuex';

export default {
  name: "ExclusionCard",

  components: {
    TwoLineCell,
  },

  data: () => ({
    formatter: null,
  }),

  mixins: [
    MajorityMixin,
  ],

  computed: {
    ...mapGetters({
      beneficiary: 'majority/beneficiary',
    })
  },

  created() {
    this.formatter = new Formatters();
  },
}
</script>
